import React, { useContext, useCallback } from 'react';
import { compareString, compareNumber } from '@togglecorp/fujs';
import { IoChevronDown, IoChevronForward } from '../../node_modules/react-icons/io5/index.esm.js';
import Button from '../Button/index.js';
import HeaderCell from './HeaderCell/index.js';
import Cell from './Cell/index.js';
import NumberOutput from '../NumberOutput/index.js';
import { RowExpansionContext } from './useRowExpansion.js';
import { genericMemo } from '../../utils/index.js';

var _IoChevronDown, _IoChevronForward;

function ExpandButton(props) {
  const {
    id
  } = props;
  const {
    expandedRowKey,
    setExpandedRowKey
  } = useContext(RowExpansionContext);
  const handleClick = useCallback(() => {
    const rowKey = id;
    setExpandedRowKey(oldValue => oldValue === rowKey ? undefined : rowKey);
  }, [setExpandedRowKey, id]);
  return /*#__PURE__*/React.createElement(Button, {
    name: undefined,
    variant: "action",
    onClick: handleClick,
    title: id === expandedRowKey ? 'Collapse' : 'Expand'
  }, id === expandedRowKey ? _IoChevronDown || (_IoChevronDown = /*#__PURE__*/React.createElement(IoChevronDown, null)) : _IoChevronForward || (_IoChevronForward = /*#__PURE__*/React.createElement(IoChevronForward, null)));
}

genericMemo(ExpandButton);
function createStringColumn(id, title, accessor, options) {
  const item = {
    id,
    title,
    cellAsHeader: options === null || options === void 0 ? void 0 : options.cellAsHeader,
    headerCellRenderer: HeaderCell,
    headerCellRendererParams: {
      sortable: options === null || options === void 0 ? void 0 : options.sortable,
      filterType: options === null || options === void 0 ? void 0 : options.filterType,
      orderable: options === null || options === void 0 ? void 0 : options.orderable,
      hideable: options === null || options === void 0 ? void 0 : options.hideable
    },
    cellRenderer: Cell,
    cellRendererParams: (_, datum) => ({
      value: accessor(datum),
      tooltip: accessor(datum)
    }),
    valueSelector: accessor,
    valueComparator: (foo, bar) => compareString(accessor(foo), accessor(bar)),
    columnClassName: options === null || options === void 0 ? void 0 : options.columnClassName,
    columnWidth: options === null || options === void 0 ? void 0 : options.columnWidth,
    columnStyle: options === null || options === void 0 ? void 0 : options.columnStyle
  };
  return item;
}
function createNumberColumn(id, title, accessor, options) {
  const item = {
    id,
    title,
    cellAsHeader: options === null || options === void 0 ? void 0 : options.cellAsHeader,
    headerCellRenderer: HeaderCell,
    headerCellRendererParams: {
      sortable: options === null || options === void 0 ? void 0 : options.sortable,
      filterType: options === null || options === void 0 ? void 0 : options.filterType,
      orderable: options === null || options === void 0 ? void 0 : options.orderable,
      hideable: options === null || options === void 0 ? void 0 : options.hideable
    },
    cellRenderer: NumberOutput,
    cellRendererParams: (_, datum) => ({
      value: accessor(datum),
      tooltip: accessor(datum)
    }),
    valueSelector: accessor,
    valueComparator: (foo, bar) => compareNumber(accessor(foo), accessor(bar)),
    columnClassName: options === null || options === void 0 ? void 0 : options.columnClassName,
    columnWidth: options === null || options === void 0 ? void 0 : options.columnWidth,
    columnStyle: options === null || options === void 0 ? void 0 : options.columnStyle
  };
  return item;
}

export { createNumberColumn, createStringColumn };
//# sourceMappingURL=predefinedColumns.js.map
